import React, { useState } from "react";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { FaYoutube, FaPray, FaBroadcastTower, FaExternalLinkAlt } from "react-icons/fa";

// ✅ 유튜브 채널 정보 설정
const YOUTUBE_CHANNEL_HANDLE = "@비나이다LIVE";
const YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@%EB%B9%84%EB%82%98%EC%9D%B4%EB%8B%A4LIVE";
const YOUTUBE_LIVE_URL = "https://www.youtube.com/@%EB%B9%84%EB%82%98%EC%9D%B4%EB%8B%A4LIVE/live";

// ✅ [방법 1] 채널 ID가 있을 경우: 해당 채널의 현재 실시간 방송이 자동 임베드됩니다.
// 채널 ID 예시: "UCxxxxxxxxxxxxxxxxxxxx" (채널 ID를 넣으면 라이브가 켜졌을 때 자동 송출됩니다)
const YOUTUBE_CHANNEL_ID = ""; 

// ✅ [방법 2] 특정 영상 ID가 있는 경우 (샘플 또는 지정 라이브 영상)
const SAMPLE_VIDEO_ID = "_fdGdOF7R8I";

const LivePrayPage = () => {
  const [useFallback, setUseFallback] = useState(false);

  // 라이브 자동 임베드 URL (채널 ID가 설정되어 있으면 실시간 자동 송출, 없으면 영상 ID로 재생)
  const embedUrl = YOUTUBE_CHANNEL_ID && !useFallback
    ? `https://www.youtube.com/embed/live_stream?channel=${YOUTUBE_CHANNEL_ID}&autoplay=1&rel=0`
    : `https://www.youtube.com/embed/${SAMPLE_VIDEO_ID}?autoplay=1&rel=0`;

  return (
    <div style={{ backgroundColor: "#f8f5f0", minHeight: "100vh", paddingBottom: "60px" }}>
      {/* 페이지 상단 헤더 */}
      <div
        style={{
          background: "linear-gradient(135deg, #6B4226 0%, #009590 100%)",
          padding: "50px 0 40px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* 배경 장식 */}
        <div
          style={{
            position: "absolute",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundImage:
              "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.05) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255,255,255,0.05) 0%, transparent 50%)",
          }}
        />

        <Container style={{ position: "relative", zIndex: 1 }}>
          <div className="d-flex justify-content-center align-items-center gap-3 mb-3 flex-wrap">
            <FaYoutube size={40} color="#FF0000" />
            <h1
              style={{
                color: "#fff",
                fontWeight: "700",
                fontSize: "2rem",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              실시간 소원기도 (비나이다LIVE)
            </h1>
            <Badge
              style={{
                backgroundColor: "#FF0000",
                fontSize: "0.75rem",
                padding: "5px 10px",
                borderRadius: "20px",
                animation: "pulse 1.5s infinite",
              }}
            >
              <FaBroadcastTower size={10} className="me-1" />
              LIVE
            </Badge>
          </div>
          <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "1rem", margin: 0 }}>
            지금 이 순간, 함께 기도드립니다
          </p>
        </Container>
      </div>

      <Container className="mt-4">
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            {/* YouTube 영상 임베드 */}
            <Card
              style={{
                border: "none",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  paddingBottom: "56.25%", // 16:9 비율
                  height: 0,
                  backgroundColor: "#000",
                }}
              >
                <iframe
                  src={embedUrl}
                  title="비나이다 실시간 소원기도 LIVE"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  onError={() => setUseFallback(true)}
                />
              </div>
            </Card>

            {/* 유튜브 채널 바로가기 및 소원기도 안내 카드 */}
            <Card
              className="mt-4"
              style={{
                border: "none",
                borderRadius: "16px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
              }}
            >
              <Card.Body className="p-4">
                <div className="d-flex align-items-start gap-3">
                  <FaPray size={28} color="#009590" style={{ flexShrink: 0, marginTop: "2px" }} />
                  <div className="w-100">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                      <h5 style={{ fontWeight: "600", color: "#333", margin: 0 }}>
                        소원기도 실시간 방송 안내
                      </h5>
                      <a
                        href={YOUTUBE_LIVE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-danger d-inline-flex align-items-center gap-2 fw-semibold px-3 py-1.5"
                        style={{ borderRadius: "8px" }}
                      >
                        <FaYoutube size={16} />
                        비나이다LIVE 바로가기 <FaExternalLinkAlt size={11} />
                      </a>
                    </div>
                    <p style={{ color: "#666", lineHeight: "1.7", marginBottom: "8px" }}>
                      유튜브 <strong>{YOUTUBE_CHANNEL_HANDLE}</strong> 채널에서 진행되는 실시간 기도 방송이 웹사이트에 생중계됩니다.
                      방송 중에는 채팅으로 소원을 남겨주시면 함께 기도를 올립니다.
                    </p>
                    <p style={{ color: "#666", lineHeight: "1.7", marginBottom: 0 }}>
                      유튜브 앱에서 직접 시청하거나 구독하시려면{" "}
                      <a
                        href={YOUTUBE_CHANNEL_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#009590", fontWeight: "600" }}
                      >
                        비나이다LIVE 채널({YOUTUBE_CHANNEL_HANDLE})
                      </a>
                      으로 이동해 주세요.
                    </p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <style>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.6; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default LivePrayPage;
